import { useState } from "react";
import { useBoolean } from "@fluentui/react-hooks";
import { IUbicacionCompletoDTO } from "../../../../Interfaces/auxiliar/IUbicacion";
import {
  DetailsListLayoutMode,
  ICommandBarItemProps,
  Icon,
  TooltipHost,
} from "@fluentui/react";
import IconHelper from "../../../../utils/helpers/iconHelper";
import { UseUbicacionHazard } from "./UseUbicacionHazard";
import { CabeceraTable } from "../../../../components/Table/CabeceraTable";
import { TableBaseComponent } from "../../../../components/Table/TableBaseComponent";
import themeBase from "../../../../utils/theme/themeBase";
import { PanelNuevoUbicacion } from "./nuevoUbicacion/PanelNuevoUbicacion";
import { PanelActualizarUbi } from "./actualizarUbi/PanelActualizarUbi";
import { PanelOcultoUbicacion } from "./ocultoUbicacion/PanelOcultoUbicacion";

export interface IUbicacionHazard {
  nivel: number;
  nombreNivel: string;
  descripcion: string;
}
export const UbicacionHazard = (props: IUbicacionHazard) => {
  const [
    isOpenPanelCrear,
    { setTrue: openPanelCrear, setFalse: closePanelCrear },
  ] = useBoolean(false);
  const [
    isOpenEliminar,
    { setTrue: openPanelEliminar, setFalse: closePanelEliminar },
  ] = useBoolean(false);
  const [item, setItem] = useState<IUbicacionCompletoDTO>({
    ubicacionId: "",
    nombre: "",
    codigo: "",
    nivel: 0,
    numeracion: 0,
    esOculto: false,
  });
  const [
    isOpenEditar,
    { setTrue: openPanelEditar, setFalse: closePanelEditar },
  ] = useBoolean(false);
  const {
    items,
    filter,
    setFilter,
    loading,
    pagination,
    handleResetUpdate,
    onChangeSearch,
    onChangeTake,
    _onkeyUpSearchTable,
  } = UseUbicacionHazard(props);

  const buttonLeft: ICommandBarItemProps[] = [
    {
      ...IconHelper.ICON_ADD_TABLE,
      text: "Nuevo",
      onClick: openPanelCrear,
    },
    {
      ...IconHelper.ICON_RELOAD,
      text: "Actualizar",
      onClick: () => {
        handleResetUpdate();
      },
    },
  ];
  const _columns = [
    {
      key: "modelo",
      name: "Nombre",
      fieldName: "nombre",
      minWidth: 100,
      maxWidth: 300,
    },
    {
      key: "opciones",
      name: "Opciones",
      minWidth: 2,
      maxWidth: 2,
      fieldName: "opciones",
      onRender: (item: IUbicacionCompletoDTO) => renderOpciones(item),
    },
  ];
  function renderOpciones(item: IUbicacionCompletoDTO) {
    return (
      <>
        <TooltipHost content={"Editar"}>
          <Icon
            iconName="Edit"
            className={themeBase.classNamesIcon.iconFont}
            style={{ cursor: "pointer", color: "#0078d3" }}
            onClick={() => {
              setItem(item);
              openPanelEditar();
            }}
          />
        </TooltipHost>
        {item.esOculto ? (
          <TooltipHost content={"Integrar"}>
            <Icon
              iconName="Add"
              className={themeBase.classNamesIcon.iconFont}
              style={{ cursor: "pointer", color: "#0078d3" }}
              onClick={() => {
                setItem(item);
                openPanelEliminar();
              }}
            />
          </TooltipHost>
        ) : (
          <TooltipHost content={"Ocultar"}>
            <Icon
              iconName="Delete"
              className={themeBase.classNamesIcon.iconFont}
              style={{ cursor: "pointer", color: "#0078d3" }}
              onClick={() => {
                setItem(item);
                openPanelEliminar();
              }}
            />
          </TooltipHost>
        )}
      </>
    );
  }
  return (
    <>
      <CabeceraTable
        Titulo={props.nombreNivel}
        SubTitulo={`Gestión de ${props.descripcion}`}
        placeholder="Buscar Por Nombre"
        componentRef={onChangeSearch}
        onKeyUp={_onkeyUpSearchTable}
      />
      <TableBaseComponent
        leftBar={buttonLeft}
        rigthBar={[]}
        data={items}
        column={_columns}
        isLoading={loading}
        getPageSize={onChangeTake}
        pagination={pagination}
        layout={DetailsListLayoutMode.justified}
        tableSiza
      />
      <PanelNuevoUbicacion nivel={props.nivel} isOpen={isOpenPanelCrear} 
      onDismiss={closePanelCrear} reload={handleResetUpdate}/>
      <PanelActualizarUbi item={item} isOpen={isOpenEditar} onDismiss={closePanelEditar}
      reload={handleResetUpdate}/>
       <PanelOcultoUbicacion item={item} isOpen={isOpenEliminar} onDismiss={closePanelEliminar}
      reload={handleResetUpdate}/>
    </>
  );
};
